import { useState } from 'react'
import { Col, Row, Container } from 'reactstrap'
import { Menu } from '../Menu'
import { Steps } from '../Steps'
import { MultipleBids } from '../MultipleBids'
import { ProposalCreation } from '../ProposalCreation'
import { PipelineSetup } from '../PipelineSetup'
import { getActivePage } from '../helpers'

const HelpCenterContent = () => {
  const [page, setPage] = useState(getActivePage)

  return (
    <Container>
      <Row>
        <Col lg="2">
          <Menu page={page} setPage={setPage} />
        </Col>
        <Col lg="10">
          {page === 'steps' && <Steps />}
          {page === 'multipleBids' && <MultipleBids />}
          {page === 'proposalCreation' && <ProposalCreation />}
          {page === 'pipelineSetup' && <PipelineSetup />}
        </Col>
      </Row>
    </Container>
  )
}

export default HelpCenterContent
